// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer___06EL","subheader":"ReorderModal_subheader__aPuXI","listWrap":"ReorderModal_listWrap__pl4dS"};